import React, { useEffect } from 'react';
import SalesOrderForm from '../../Components/Form/SalesOrderForm/SalesOrderForm';
import FormLayout from '../../Components/Layout/FormLayout';
import { SalesOrderIcon } from '../../Assets/Navigation/NavigationIcons';
import { t } from 'i18next';

const EditSalesOrder = (props) => {
  useEffect(() => {
    document.title = `${t('common.edit')} ${t('saleOrder.sales_orders')}`;
  }, []);

  return (
    <FormLayout
      title={`${t('common.edit')} ${t('saleOrder.sales_orders')}`}
      Icon={SalesOrderIcon}
      closeUrl="/salesorders"
      iconstyle="general_module_icon"
      layoutBoxClass="uiux-form-redesign"
    >
      <SalesOrderForm
        type="edit"
        id={
          props.idFromHeaderWrapper
            ? props.idFromHeaderWrapper
            : props.match.params.id
        }
        handleToast={props.handleToast}
      />
    </FormLayout>
  );
};

export default EditSalesOrder;
